export default __webpack_public_path__ + "static/media/empty-box.b89d74a6.png";